import 'semantic-ui/dist/semantic.min.js';
import './semantic/dist/semantic.min.css';
import './App.sass';
import React, { Component } from 'react';
import { Container } from 'semantic-ui-react'

import siteConfig from 'siteConfig.js';
import Nav from './components/Nav/Nav.js';
import Hero from './components/Hero/Hero.js';
import ImpactSpace from './components/ImpactSpace/ImpactSpace.js';
import Header from './components/Header/Header.js';


class App extends Component {
	state = { visibleNav: false };

	handleContextRef = contextRef => this.setState({ contextRef });
	hideNav = () => this.setState({ visibleNav: false });
	showNav = () => this.setState({ visibleNav: true });

	render() {
		const impactSpaces = siteConfig.impactSpaces.map((el, idx) =>
			<ImpactSpace config={el} key={idx}></ImpactSpace>
		);

		const { visibleNav } = this.state;

		return (
			<div id="App" className="App" ref={this.handleContextRef}>
				<Header onMenuClick={this.showNav}></Header>
				<Nav visible={visibleNav} hideNav={this.hideNav}></Nav>
				<Container className="defaultGutters">
					<Hero></Hero>
					{impactSpaces}
				</Container>
			</div>
		);
	}
}

export default App;
